// EditUserDialog.jsx

import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';

const EditUserDialog = ({ open, onClose, user, onSave }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState(''); // New state for email
  const [address, setAddress] = useState('');
  const [permission, setPermission] = useState(''); // New state for permission
  const [errors, setErrors] = useState({}); // State for form validation errors

  // Pre-fill the user data when the dialog opens
  useEffect(() => {
    if (user) {
      setName(user.name || '');
      setEmail(user.email || ''); // Populate email
      setAddress(user.address || '');
      setPermission(user.permission || '');
    }
  }, [user]);

  // Validate form fields
  const validate = () => {
    const newErrors = {};

    if (!name.trim()) {
      newErrors.name = 'Name is required.';
    }

    if (!email.trim()) {
      newErrors.email = 'Email is required.';
    } else {
      // Simple email regex for validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        newErrors.email = 'Invalid email format.';
      }
    }

    // Add more validations as needed

    setErrors(newErrors);

    // If no errors, return true
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = () => {
    if (validate()) {
      onSave({ name, email, address, permission }); // Include email in the save function
    }
  };

  const handleCancel = () => {
    setErrors({}); // Reset errors on cancel
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleCancel} fullWidth maxWidth="sm">
      <DialogTitle>Edit User</DialogTitle>
      <DialogContent>
        <TextField
          margin="dense"
          label="Name"
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
          error={Boolean(errors.name)}
          helperText={errors.name}
        />
        <TextField
          margin="dense"
          label="Email"
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          error={Boolean(errors.email)}
          helperText={errors.email}
        />
        <TextField
          margin="dense"
          label="Address"
          fullWidth
          value={address}
          onChange={(e) => setAddress(e.target.value)}
        />
        <FormControl fullWidth margin="dense">
          <InputLabel>Permission</InputLabel>
          <Select
            value={permission}
            onChange={(e) => setPermission(e.target.value)}
          >
            <MenuItem value="view">View</MenuItem>
            <MenuItem value="edit">Edit</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSave} color="primary" variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditUserDialog;
